<app-search-sticky-bar class="footerSearch" *ngIf="isLoggedIn && windowType === 'mobile'"></app-search-sticky-bar>
<div class="gamesdefaultbg" [ngClass]="[ isGameminimized===true ? 'floating_hide':'']" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + mediaPath + '/game-window-bg.png)'}">
  <div class="gamesbg" [ngStyle]="{'background-image': gamePathUrl ? 'url(' + gamePathUrl + ')' : 'none'}" [ngClass]="manageGameWindowWidth ? 'w94p' : 'w100p'">
    <div class="container-fluid">
      <div class="games_workspace" [ngClass]="[
          aspectRatio === 2 ? 'four-three': 'sixteen-nine',
          isLoggedIn === true ? 'loggedin' : '',
          landScapeMode ? 'disable-footer' : '',
          isGameminimized===true ? 'floating_game':''
        ]" [ngStyle]="{'width': gameWindowWidth + 'px'}">
        <div class="middleAlignBlock">
          <div class="middleAlign">

            <!-- Default games launcherr -->
            <div id="gameIframeWrapper" [ngClass]="vendorSlug !== 'play-n-go' ? 'show' : 'hide'" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + mediaPath + '/' +websiteName+'-logo.'+websiteLogoExtension+')'}">

            </div>
            <div class="game_maximize" (click)="takeToGamepage()">
              <i class="icon-play"></i>
            </div>
            <div class="gamewindow hide-below-992">

              <button (click)="goBackPage()" class="close gamewindow_close-btn">
                <i class="gamewindow--close"></i>
              </button>
              <button (click)="gameMiniWindow()" class="minimize">
                <i class="gamewindow--minimize"></i>
              </button>

            </div>

            <!-- Play n go games launcher -->
            <div id="idPlayNGoScript" *ngIf="vendorSlug === 'play-n-go'"></div>
            <div class="playNGoWrap" [ngClass]="vendorSlug === 'play-n-go' ? 'show' : 'hide'" [ngStyle]="{'background-image': 'url(/assets/img/'+websiteName+'-logo.'+websiteLogoExtension+')'}"></div>

            <div class="gamewindow_info hide-below-992">
              <div class="gamewindow_notify">
                <p class="gamewindow_notify--para">
                  <ng-container *ngIf="!isLoggedIn"> {{'gameOfflineNotify.text' | translate}} </ng-container>
                  <ng-container *ngIf="isLoggedIn"> {{'gameOfflineNotify.real_text' | translate}} </ng-container>
                  <span class="gamewindow_notify--link" *ngIf="!isLoggedIn"
                    (click)="goToRegister()">{{'gameOfflineNotify.link' | translate}}</span>
                </p>
               
                <button class="site-btn site-btn__primary"
                  (click)="goToRegister()">{{'gameOfflineNotify.mobButtonText' | translate}}</button>
              </div>
              
            </div>
            <div class="show-below-992">
              <div class="gamewindow_mobile--login" *ngIf="!isLoggedIn && windowType === 'mobile'">
                <p class="gamewindow_mobile--link demo__txt">{{'gameOfflineNotify.text' | translate}}</p>
                <span href="" class="gamewindow_mobile--link active demo__reg--link"
                (click)="goToRegister()">{{ 'gameOfflineNotify.gamewindowSign' | translate }}</span>
              </div>
            </div>

            <div class="gamewindow_notify gamewindow_notify_LoggedIn" *ngIf="isLoggedIn && windowType === 'mobile'">
              <a class="main_header--logo" routerLink="{{langCode+'/'}}" (click)="goToTop()">
                <img src="{{siteUrlPath}}/{{mediaPath}}/common/{{websiteName}}-m-logo-login.{{websiteLogoExtension}}" alt="{{websiteName}}.com logo" title="{{websiteName}}.com" />
              </a>
              <p class="gamewindow_mobile--link" (click)="openSearch()">
                <span class="search_txt">{{'gameOfflineNotify.search' | translate}}</span>
                <span class="search_icon"><i class="icon icon-search-1"></i></span>
              </p>
              <button class="site-btn site-btn__primary mob_topUpBtn"
                (click)="openDeposit()">
                {{'gameOfflineNotify.deposit' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<app-games-content *ngIf="isGameminimized !== true"></app-games-content>



<modal id="suspendAccountModalInGame">
  <div class="modal">
    <div class="middleAlignBlock">
      <div class="middleAlign">
        <div class="suspend_acnt_block">
          <div class="hidden-sm hidden-xs icon-cancel-svg" (click)="close('suspendAccountModalInGame')"></div>
          <div class="hidden-md hidden-lg mobile_modal_closeicon" (click)="close('suspendAccountModalInGame')">
            <i class="icon-cancel-1"></i>
          </div>
          <div class="modal-body modal-popup-body">
            <div *ngIf="!exclusionPasswordPage">
              <h3>{{'gameModal.cool_off' | translate}}</h3>
              <p>{{'gameModal.areyou_suspend_23hours' | translate}}</p>
              <div class="sus_frm_block clearfix">
                <button id="panic_self_exclusion" type=button
                  class="panic_self_exclusion site-btn site-btn__primary site-btn--lg" (click)="confirmSusupend()">
                  <span>{{'gameModal.Confirm' | translate}}</span></button>
              </div>
              <hr class="hidden-xs" />
              <p class="sus_frm_footer" (click)="close('suspendAccountModalInGame')">
                {{'accountstatusComp.accountstatus20' | translate}}</p>
            </div>
            <div *ngIf="exclusionPasswordPage">
              <h3>{{'accountstatusComp.accountstatus12' | translate}}</h3>
              <p>{{'accountstatusComp.accountstatus13' | translate}} {{'suspend'}}
                {{'accountstatusComp.accountstatus21' | translate}} {{'for 24 hours'}}.
              </p>
              <div class="sus_frm_block clearfix">
                <form [formGroup]="suspendAccountForm" novalidate>
                  <div class="form-group">
                    <div class="controls passwrd" [ngClass]="getFormFiledClass('password',suspendAccountForm)">
                      <input [type]="viewPassword ? 'text' : 'password'" formControlName="password" name="password"
                        id="password" class="floatLabel form-control" (focus)="onFocusForElement('password')"
                        (focusout)="onFocusOutForElement()" />
                      <label for="password">{{'accountstatusComp.accountstatus14' | translate}}</label>
                    </div>
                    <span class="pwd-show" [ngClass]="viewPassword? 'eyeshow' : ''"
                      (click)="viewPassword = !viewPassword"><i class="icon-icon-eye"></i></span>
                    <div class="arrow_box_small" *ngIf="shouldShowErrors('password',suspendAccountForm)">
                      {{getErrorMessage('password',suspendAccountForm)}}</div>
                  </div>
                  <button type="button" id="panic_self_exclusion"
                    class="button_margin site-btn site-btn__primary site-btn--lg"
                    (click)="panicExclusion('panic_self_exclusion')">
                    <span>{{'Suspend'}}</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>